import { render, staticRenderFns } from "./TransferTerms.vue?vue&type=template&id=4c5bb8fa&scoped=true"
import script from "./TransferTerms.vue?vue&type=script&lang=js"
export * from "./TransferTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5bb8fa",
  null
  
)

export default component.exports